var calculator = (function () {
    "use strict";

    var calculators = $('.calculator'),
        calculatorWrap = $('.calculator-wrapper'),
        brand = $('body').data('section'),
        earnings = $('.earnings'),
        controls = $('.control'),
        productList = $("ul li input", calculators),
        scrollSpeed = 350,
        isteamcalculator = calculators.hasClass("team-type");

    // Listeners
    $(".bubble .close", calculators).click(function () {
        $(this).closest(".bubble").hide();
    });
    productList.change(function () {
        if (isteamcalculator) {
            var calculators = $('.control-item', calculatorWrap);
            calculators.hide();
            calculators.eq($(this).parent().index()).show();
            $(".goal .submit-btn").click();
        }
    });

    calculatorWrap.on('click', '.goal .submit-btn', function (e) {
        e.preventDefault();
        var $this = $(this);

        if (isteamcalculator) {
            var calculator = $('.control:visible', calculatorWrap),
                salespersons = $("#calculator-salespersons").val(),
                ticketsperperson = $("#calculator-ticketsperperson").val();
            if (salespersons != "" && ticketsperperson != "") {
                calculator.slider('value', Math.ceil(parseInt(salespersons) * parseInt(ticketsperperson)));
            }
            else {
                calculator.slider('value', 0);
            }
            calculateEarnings.call($this);
        }
        else {
            if (brand === 'association' || brand === 'team') {
                calculateForeningMulti($this);
            }
            if (brand === 'store') {
                calculateButikMulti($this);
            }
        }
    });

    calculators.on('keypress', '#calculator-goal', function (e) {

        var $this = $(this);

        if (e.keyCode === 13) {
            e.preventDefault();
            $this.next().trigger('click');
        }
    });


    // fade in calculators after delay to avoid height issue when jquery ui-slider plugin loads
    setTimeout(function () {
        calculators.fadeIn(100);
    }, 80);

    function calculateForeningMulti($this) {

        var value = $('#calculator-goal').val().replace(/ /g, ''),
            goalPerProduct = value / $(".control-item", calculatorWrap).filter(function (index) {
                return productList.length == 0 || productList.eq(index).is(":checked")
            }).length;

        if (productList.filter("[value='bingolotto']").length > 0) {
            bingolottoForening(productList.filter("[value='bingolotto']").is(":checked") ? goalPerProduct : 0);
        }
        if (productList.filter("[value='bingolottopren']").length > 0) {
            bingolottoPrenumeration(productList.filter("[value='bingolottopren']").is(":checked") ? goalPerProduct : 0);
        }
        if (productList.filter("[value='sverigelotten']").length > 0) {
            sverigelottenForening(productList.filter("[value='sverigelotten']").is(":checked") ? goalPerProduct : 0);
        }
        if (productList.filter("[value='julkalender']").length > 0) {
            julkalendernForening(productList.filter("[value='julkalender']").is(":checked") ? goalPerProduct : 0);
        }
        if (productList.filter("[value='kosing']").length > 0) {
            kosingForening(productList.filter("[value='kosing']").is(":checked") ? goalPerProduct : 0);
        }

        calculateEarnings.call($this);
    }

    function calculateButikMulti($this) {

        var value = $('#calculator-goal').val().replace(/ /g, ''),
            goalPerProduct = value / $(".control-item", calculatorWrap).filter(function (index) {
                return productList.length == 0 || productList.eq(index).is(":checked")
            }).length;

        if (productList.filter("[value='bingolotto']").length > 0) {
            bingolottoButik(productList.filter("[value='bingolotto']").is(":checked") ? goalPerProduct : 0);
        }
        if (productList.filter("[value='sverigelotten']").length > 0) {
            sverigelottenButik(productList.filter("[value='sverigelotten']").is(":checked") ? goalPerProduct : 0);
        }
        if (productList.filter("[value='julkalender']").length > 0) {
            julkalendernButik(productList.filter("[value='julkalender']").is(":checked") ? goalPerProduct : 0);
        }
        if (productList.filter("[value='kosing']").length > 0) {
            kosingButik(productList.filter("[value='kosing']").is(":checked") ? goalPerProduct : 0);
        }

        calculateEarnings.call($this);
    }

    function bingolottoButik(goalPerProduct) {
        var calculator = $('.control[data-id="bingolotto"]'),
            data = calculator.data(),
            number = goalPerProduct / (data.levels[0] * data.redeem);

        calculator.slider('value', Math.ceil(number));
    }

    function sverigelottenButik(goalPerProduct) {
        var calculator = $('.control[data-id="sverigelotten"]'),
            data = calculator.data(),
            number = goalPerProduct / (data.levels[0] * data.redeem);

        calculator.slider('value', Math.ceil(number));
    }

    function julkalendernButik(goalPerProduct) {
        var calculator = $('.control[data-id="julkalender"]'),
            data = calculator.data(),
            number = goalPerProduct / (data.levels[0] * data.redeem);

        calculator.slider('value', Math.ceil(number));
    }

    function kosingButik(goalPerProduct) {
        var calculator = $('.control[data-id="kosing"]');
        if (calculator.length == 0)
            return;
        var data = calculator.data(),
            number = goalPerProduct / (data.levels[0] * data.redeem);

        calculator.slider('value', Math.ceil(number));
    }

    function bingolottoForening(goalPerProduct) {

        var calculator = $('.control[data-id="bingolotto"]'),
            data = calculator.data(),
            level1sum = data.levels[0] * 2299,
            number;

        if (goalPerProduct < level1sum) {
            number = goalPerProduct / data.levels[0];
        } else {
            number = 2299 + (goalPerProduct - level1sum) / data.levels[1];
        }

        calculator.slider('value', Math.ceil(number));
    }

    function bingolottoPrenumeration(goalPerProduct) {
        var calculator = $('.control[data-id="bingolottopren"]'),
            data = calculator.data(),
            number = goalPerProduct / data.levels[0];

        calculator.slider('value', Math.ceil(number));
    }

    function sverigelottenForening(goalPerProduct) {

        var calculator = $('.control[data-id="sverigelotten"]'),
            data = calculator.data(),
            level1sum = 1999 * data.levels[0],
            level2sum = 2999 * data.levels[1],
            level3sum = 9999 * data.levels[2],
            number;

        if (goalPerProduct > level3sum) { number = goalPerProduct / data.levels[3]; }
        if (goalPerProduct < level3sum) { number = goalPerProduct / data.levels[2]; }
        if (goalPerProduct < level2sum) { number = goalPerProduct / data.levels[1]; }
        if (goalPerProduct < level1sum) { number = goalPerProduct / data.levels[0]; }

        calculator.slider('value', Math.ceil(number));
    }

    function julkalendernForening(goalPerProduct) {
        var calculator = $('.control[data-id="julkalender"]'),
            data = calculator.data(),
            number = goalPerProduct / data.levels[0];

        calculator.slider('value', Math.ceil(number));
    }

    function kosingForening(goalPerProduct) {
        var calculator = $('.control[data-id="kosing"]');
        if (calculator.length == 0)
            return;
        var data = calculator.data(),
            number = goalPerProduct / data.levels[0];

        calculator.slider('value', Math.ceil(number));
    }


    // Initialize each calculator
    controls.each(function (i) {

        var $this = $(this),
            data = $this.data(),
            info = $this.closest('.control-item').find('.control-info p'),
            popUp = $('<div class="control-popup">'),
            popCounter = $('<span>', {
                "class": 'pop-counter',
                "data-id": data.id,
                text: '0'
            }).appendTo(popUp);

        $this.slider({
            animate: 850,
            value: data.val || 0,
            step: 1,
            min: data.min,
            max: data.max,
            range: "min",
            create: function (ui) {
                $this.find('.ui-slider-handle').append(popUp);
                popCounter.text(data.val);

                calculateEarnings.call($this);
            },
            slide: function (e, ui) {
                popCounter.text(ui.value);
                if (ui.value > 0) {
                    info.fadeIn(70);
                    popUp.fadeIn(70);
                }
                calculateEarnings.call($this, ui.value);
            },
            change: function (e, ui) {
                popCounter.text(ui.value);
            }
        });
    });

    function getSliderEarnings(data, value) {
        var earningsPerItem, ret = {};

        var multiple = 1;
        if (data.weekCalc) {
            multiple = 46;
        }

        switch (data.id) {
            case 'bingolotto':
                if (brand === 'association' || brand === 'team') {
                    var sellBreakpoint = 2300;

                    if (data.weekCalc) {
                        sellBreakpoint = 50;
                    }

                    if (value > sellBreakpoint) {
                        earningsPerItem = data.levels[1];
                        ret['total'] = (sellBreakpoint * data.levels[0] * multiple) + (value - sellBreakpoint) * data.levels[1] * multiple;
                    }
                    if (value <= sellBreakpoint) {
                        earningsPerItem = data.levels[0];
                        ret['total'] = earningsPerItem * value * multiple;
                    }
                }
                else if (brand === 'store') {
                    ret['total'] = value * data.levels[0] * data.redeem * multiple;
                    ret['redeem'] = value * data.levels[0] * (data.redeem - 1) * multiple;
                }

                break;
            case 'bingolottopren':
                ret['total'] = value * data.levels[0] * multiple;
                break;
            case 'sverigelotten':
                if (brand === 'association' || brand === 'team') {
                    if (value >= 10000) earningsPerItem = data.levels[3];
                    if (value < 10000) earningsPerItem = data.levels[2];
                    if (value < 3000) earningsPerItem = data.levels[1];
                    if (value < 2000) earningsPerItem = data.levels[0];
                    ret['total'] = earningsPerItem * value * multiple;
                }
                else if (brand === 'store') {
                    ret['total'] = value * data.levels[0] * data.redeem * multiple;
                    ret['redeem'] = value * data.levels[0] * (data.redeem - 1) * multiple;
                }
                break;

            case 'kosing':
                if (brand === 'association' || brand === 'team') {
                    ret['total'] = data.levels[0] * value * multiple;
                }
                else if (brand === 'store') {
                    ret['total'] = value * data.levels[0] * data.redeem * multiple;
                    ret['redeem'] = value * data.levels[0] * (data.redeem - 1) * multiple;
                }
                break;

            case 'julkalender':
                if (brand === 'association' || brand === 'team') {
                    ret['total'] = data.levels[0] * value * multiple;
                }
                else if (brand === 'store') {
                    ret['total'] = value * data.levels[0] * data.redeem * multiple;
                    ret['redeem'] = value * data.levels[0] * (data.redeem - 1) * multiple;
                }
                break;
        }
        return ret;
    }

    function calculateEarnings(value) {

        var thisCalculator = $(this).closest('.calculator'),
            activeSlider = $(this),
            activeCount = parseInt(activeSlider.find('.pop-counter').text(), 10),
            activeId = activeSlider.data('id'),
            resultBox = thisCalculator.find('.earnings'),
            total = 0;

        $(".control", thisCalculator).filter(function () {
            return $(this).closest(".control-item").length == 0 || $(this).closest(".control-item").css('display') != 'none';
        }).each(function (i) {
            var $this = $(this),
                counter = $this.find('.pop-counter'),
                info = $(this).closest('.control-item').find('.control-info'),
                value = parseInt(counter.text(), 10),
                data = $this.data();

            var earningsObj = getSliderEarnings(data, value);
            total += earningsObj.total;

            if (brand === 'store') {
                info.find('.redeem').html(Math.floor(earningsObj.redeem));
                switch (data.id) {
                    case 'bingolotto':
                        info.find('.num').html(value);
                        info.find('.per-hour').html((value / (46 * 10 * 7)).toFixed(2));
                        break;

                    case 'sverigelotten':
                        info.find('.num').html(value);
                        info.find('.per-hour').html((value / (52 * 10 * 7)).toFixed(2));
                        break;

                    case 'kosing':
                        info.find('.num').html(value);
                        info.find('.per-hour').html((value / (52 * 10 * 7)).toFixed(2));
                        break;

                    case 'julkalender':
                        info.find('.tickets-sold').hide();
                        break;
                }
            }
        });

        resultBox.text(Math.floor(parseInt(total, 10) / 100) * 100);
    }

    function scrollTo(e) {
        e.preventDefault();
        var href = $(this).attr('href');

        if (href) {
            $('html, body').animate({
                scrollTop: $(href).offset().top
            }, scrollSpeed);
        }
    }
})();